<template>
	<div>
		<div class="row">
			<div class="column-sidebar-left">
				<AdvancedSearchMenu></AdvancedSearchMenu>
			</div>
			<div class="column-main-right">
				<div class="content-container">
					<div class="header">
						<div class="title">Attachment</div>
					</div>
					<div class="content">
						<div class="started-by-container">
                            <div class="started-by-label">
                                File Name:
                            </div>
                            <div class="started-by-value">
                                <input class="started-by-input" type="text" v-model="filename">
                            </div>
                        </div>
                        <div class="exact-match-container">
                            <input type="checkbox" v-model="exactMatch">
                            <span>Exact Match</span>
                        </div>
                        <div class="title-container">
                            <div class="title-label">
                                Added by:
                            </div>
                            <div class="title-value">
                                <input class="title-input" type="text" v-model="addedBy">
                            </div>
                        </div>
                        <div class="exact-match-container">
                            <input type="checkbox" v-model="exactMatchAddedBy">
                            <span>Exact Match</span>
                        </div>
                        <div class="start-date-container">
                            <div class="start-date-label">
                                Start Date
                            </div>
                            <div class="start-date-value">
                                <div>
                                    <input type="radio" name="between" value="between" v-model="startDateType">
                                    <label for="between">Between</label>
                                    <input type="radio" name="before" value="before" v-model="startDateType">
                                    <label for="before">Before</label>
                                    <input type="radio" name="after" value="after" v-model="startDateType">
                                    <label for="after">After</label>
                                </div>
                                <div>
                                    <vc-date-picker :class="{hidden: !(startDateType == 'between' || startDateType == 'after')}"
                                        v-model='dateAfter'
                                        class="date-picker"
                                        :max-date="dateBefore"
                                        :input-props='{
                                            style:"width:90px; font-size: 14px; margin-bottom: 6px;"
                                        }'
                                    />
                                    <span style="padding: 0px 6px;" :class="{hidden: !(startDateType == 'between')}">and</span>
                                    <vc-date-picker :class="{hidden: !(startDateType == 'between' || startDateType == 'before')}"
                                        v-model='dateBefore'
                                        class="date-picker"
                                        :min-date="dateAfter"
                                        :input-props='{
                                            style:"width:90px; font-size: 14px; margin-bottom: 6px;"    
                                        }'
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="post-count-container">
                            <div class="title-label">
                                Forums(s):
                            </div>
                            <div class="title-value">
                                <select v-model="selectedBoardId">
                                    <option v-for="board in boards" :key="board.id" :value="board.id">{{board.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="search-button-container">
                            <button class="search-button" @click="search">Search</button>
                        </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AdvancedSearchMenu from "../../components/Search/AdvancedSearchMenu";
import api from '../../api/api';

export default {
    data() {
        return {
            filename: null,
            exactMatch: null,
            startDateType: null,
            dateAfter: null,
            dateBefore: null,
            addedBy: null,
            exactMatchAddedBy: null,
            postCountType: null,
            postCount: null,
            attatchments: null,
            boards: null,
            selectedBoardId: null,
        };
    },
	components: {
		AdvancedSearchMenu,
    },
    watch: {
        startDateType(newValue) {
            if (newValue == "before") {
                this.dateAfter = null;
            }
            else if(newValue == "after") {
                this.dateBefore = null;
            }
        }
    },
    methods: {
        search() {
            // alert('serach');
        },
    },
    mounted() {
        api.get('/boards').then(r=> {
            let boards = [];
            if(r && r.data) {
                for(let i = 0; i < r.data.categories.length; i++) {
                    const category = r.data.categories[i];
                    boards = boards.concat(category.boards);
                }
            }
            this.boards = boards.map(b => {
                return {
                    name: b.name,
                    id: b.id,
                }
            });
        });
    },
};
</script>

<style scoped>
.started-by-container, .start-date-container, .title-container, .post-count-container{
    display: flex;
}
.started-by-label, .start-date-label, .title-label, .post-count-label {
    min-width: 80px;
}
.post-count-label{
    font-size: 18px;
}
.started-by-value, .start-date-value, .title-value, .post-count-value{
    margin-left: 20px;
}
.post-count-value{
    position: relative;
    top: 3px;
}
.started-by-input, .title-input{
    width: 300px;
}
.start-date-value label{
    margin-right: 14px;
}
.post-count-input{
    margin-left: 20px;
    width: 80px;
}
.hidden{
    visibility: hidden;
}
.exact-match-container{
    padding-left: 8px;
}
.attatchments-container{
    font-size: 16px;
}
.search-button{
    margin-left: 350px;
    margin-top: 14px;
}
</style>